import {
    CURRENT_PERIOD_COST_VS_TIME_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    DAYS_TILL_FUNDS_ARE_OUT_COLUMN,
    FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN,
    FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    FULL_PERIOD_CONVERSIONS_COLUMN,
    FULL_PERIOD_COST_VS_PROJECTED_COLUMN,
    FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN,
    FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN,
    FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN,
    FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN,
    GOAL_1_COLUMN,
    GOAL_2_COLUMN,
    TODAY_CLICKS_COLUMN,
    TODAY_CONVERSIONS_COLUMN,
    TODAY_COST_COLUMN,
    TODAY_CPA_COLUMN,
    TODAY_CPC_COLUMN,
    TODAY_CPM_COLUMN,
    TODAY_CTR_COLUMN,
    TODAY_IMPRESSIONS_COLUMN,
    YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN,
    YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
} from '../columns';

const FLEX_COLUMN_PREFIX = 'FLEX_INDICATOR||';

/**
 * Las columnas que se pintan, o sea las únicas que ofrecen tuerca.
 *
 * Espeja `INDICATOR_BY_COLUMN` del backend (`core/presenters/columns/column_indicators.py`),
 * que es quien decide de verdad. Acá sólo sirve para no dibujar una tuerca que después el
 * endpoint va a rechazar — Etiquetas, Moneda y Comentario no tienen semáforo.
 *
 * "% Invertido vs. Tiempo" entró recién cuando dejó de pintarse con la sensibilidad del
 * indicador de Presupuesto: mientras dependía de otra columna, su tuerca habría mostrado
 * umbrales que no eran los suyos.
 *
 * ⚠️ El criterio es "qué celda la pinta", NO "de qué indicador se alimenta". «Costo de ayer»,
 * «Costo / Promedio últimos 7 días» y «CPA del período» comparten indicador con sus
 * comparativas —que sí pintan— pero se sirven con `DashboardSingleValueCell`, que muestra el
 * monto y no mira el color: ofrecerles tuerca prometía un control que no hace nada. Antes de
 * sumar una columna acá, buscala en `DashboardRow._renderCell` y confirmá que su celda
 * consume `alert_level`.
 */
const COLUMNS_WITH_SEMAPHORE = new Set([
    TODAY_CLICKS_COLUMN,
    TODAY_IMPRESSIONS_COLUMN,
    TODAY_COST_COLUMN,
    TODAY_CONVERSIONS_COLUMN,
    TODAY_CPC_COLUMN,
    TODAY_CPA_COLUMN,
    TODAY_CTR_COLUMN,
    TODAY_CPM_COLUMN,

    FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    FULL_PERIOD_COST_VS_PROJECTED_COLUMN,
    CURRENT_PERIOD_COST_VS_TIME_COLUMN,
    FULL_PERIOD_ODS_VS_YESTERDAY_COLUMN,
    FULL_PERIOD_ODS_VS_LAST_7_DAYS_COLUMN,
    FULL_PERIOD_ODS_VS_PLATFORM_BUDGET_COLUMN,
    FULL_PERIOD_CONVERSIONS_COLUMN,

    FULL_PERIOD_ROAS_VS_LAST_MONTH_COLUMN,
    FULL_PERIOD_ACOS_VS_LAST_MONTH_COLUMN,

    CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN,
    YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,

    GOAL_1_COLUMN,
    GOAL_2_COLUMN,

    DAYS_TILL_FUNDS_ARE_OUT_COLUMN,
]);

export function columnHasSemaphore(columnId) {
    if (!columnId) {
        return false;
    }
    // Las comparativas (las de la agencia, las fijas de GA4/ecommerce/paid media y las
    // derivadas de métricas personalizadas) llevan su indicador como nombre de columna.
    if (columnId.startsWith(FLEX_COLUMN_PREFIX)) {
        return true;
    }
    return COLUMNS_WITH_SEMAPHORE.has(columnId);
}

/**
 * Si ese encabezado lleva tuerca.
 *
 * El Tablero es UNA pantalla compartida: sin el gate de la 2.1, el control nuevo aparecería
 * también en el Dashbo clásico, que tiene que quedar exactamente igual que siempre.
 */
export function showsColumnSensitivityFor(isUiV2, columnId) {
    return Boolean(isUiV2) && columnHasSemaphore(columnId);
}
